import { DebuggerInstance } from '../shared/debugger';

export interface ITronLogoEvent {
    type: 'OPENGALLERY' 
        | 'OPENUPLOAD'
        | 'OPENEDITOR' 
        | 'UPLOADDONE' 
        | 'UPLOADFAIL' 
        | 'UPLOADCANCEL' 
        | 'UPLOADWRONG' 
        | 'MOTIVECHANGE' 
        | 'MOTIVESAVE' 
        | 'VISUALCREATEDONE' 
        | 'VISUALCREATEFAIL' 
        | 'VISUALSENTDONE' 
        | 'VISUALSENTFAIL';
    sid?: string;
    spcode?: string | null;
    smcode?: string | null;
    smcolor?: string | null;
    pcode?: string | null;
    pname?: string | null;
    motiveId?: string;
    productMotiveId?: string;
    visualId?: string;
    savetogallery?: boolean;
    saveandapply?: boolean;
    printtechnology?: string | null;
    email?: string;
    uploadFile?: string;
    errormsg?: string;
    motivecolorscount?: number;
    posCode?: string;
    posName?: string;
    posDef?: boolean;
    techCode?: string;
    techName?: string;
    techDef?: boolean;
    areaWidth?: number;
    areaHeight?: number;
    motiveWidth?: number;
    motiveHeight?: number;
    maxColors?: string;
}

export interface ITronLogoEventWithCustomData extends ITronLogoEvent {
    custom1?: string;
    custom2?: string;
    custom3?: string;
}

export interface IParentMessageData {
    kind: string;
}

export interface IInitData {
    apiKey: string;
    userGuid: string;
    lang?: string;
    currentLogo?: string;
}

export interface IInitMessagaData extends IParentMessageData {
    data: IInitData;
}

export class TronTrackingHandler {

    constructor() {
        DebuggerInstance.log('TronTrackingHandler - ctor');
    }

    public setLang(lang: string): void {
        // send request to parent to send init data
        DebuggerInstance.log('TronHandler - setLang');

        parent.postMessage({
            method: "tron.Modal.setUserLang",
            data: lang
        }, '*');
    }

    public setLogo(logo: string | null): void {
        // send request to parent to send init data
        DebuggerInstance.log('TronHandler - setLogo');

        parent.postMessage({
            method: "tronlogo.setCurrentLogo",
            data: logo
        }, '*');
    }

    public closeDialog(delay?: number): void {
        DebuggerInstance.log('TronHandler - closing dialog');

        parent.postMessage({
            method: "tron.Modal.closeModal",
            data: delay
        }, '*');
    }

    public tronLogoEventCallback(callbackData: ITronLogoEventWithCustomData) {
        DebuggerInstance.log('TronHandler - productMotiveCallback');
        DebuggerInstance.log(callbackData);

        parent.postMessage({
            method: "tronlogo.tronLogoEventCallback",
            data: callbackData
        }, '*');
    }
}



// WEBPACK FOOTER //
// ./src/App/tron-tracking/TronTrackingHandler.tsx